<template>
    <div>
        <div class="alert alert-warning">
            <h4>Attention {{$store.getters.username}}</h4>
            <p>Il est recommandé de consulter un médecin avant toute activité physique.</p>
            <p>Vous êtes conscient que la pratique d’une activité physique comme le "Gainage Progressif" © représente un risque potentiel de blessures.</p>
            <p>Vous vous engagez à tenir les responsables de "Gainage Progressif" © quittes et indemnes de toute réclamation,
                poursuite ou action qui pourrait être dirigée contre eux, notamment celles relatives aux frais et déboursés judiciaires et extrajudiciaires.</p>
            <p>Vous êtes seul responsable de votre entrainement.</p>
            <button class="btn btn-secondary" @click="$router.push({path: '/'})">Annuler</button>
            <button class="btn btn-warning" @click="validate">J'ai compris et j'accepte</button>
            <hr>
            <div class="form-check">
                <input class="form-check-input" type="checkbox" v-model="disclaimerAccepted" id="disclaimerCheck">
                <label class="form-check-label" for="disclaimerCheck">
                    Se souvenir de ma décision et ne plus me poser la question.
                </label>
            </div>
        </div>
    </div>
</template>

<script>
    export default  {
        data: function() {
            return {
                disclaimerAccepted : false,
            }
        },
        methods: {
            validate() {
                console.log("validate");
                if(this.disclaimerAccepted) {
                    this.$store.dispatch('updateUserParams', {disclaimerAccepted : this.disclaimerAccepted});
                }
                this.$store.dispatch('grantAccess');
                this.$router.push({path: '/training'});
            }
        }
    }


</script>


// WEBPACK FOOTER //
// src/components/Disclaimer.vue